import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { site } from "@/config/site";
import { SEO } from "@/lib/seo";
import { Reveal } from "@/components/Reveal";

export default function ThankYou() {
  const { state } = useLocation();
  const isEstimate = state?.type !== "contact";

  return (
    <>
      <SEO
        title="Thank You | North Ember Painting"
        description="Thank you for contacting North Ember Painting. We've received your request and will be in touch."
        path="/thank-you"
      />
      <section className="flex min-h-[70vh] items-center bg-alabaster py-20" data-testid="thank-you-page">
        <div className="mx-auto max-w-2xl px-4 text-center sm:px-6">
          <Reveal>
            <span className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-ember/10">
              <CheckCircle2 className="h-8 w-8 text-ember" aria-hidden="true" />
            </span>
            <h1 className="mt-6 font-display text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
              Thank you — we've received your {isEstimate ? "estimate request" : "message"}.
            </h1>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-slate-600">
              <p>
                <strong className="font-semibold text-slate-900">What happens next:</strong> we review the details
                you sent, then contact you using your preferred method to talk through your project and next steps.
              </p>
              <p>
                If anything is urgent or you'd simply rather talk it through now, call or message any time at{" "}
                <a href={site.phoneHref} data-testid="thank-you-phone" className="font-semibold text-ember-dark">
                  {site.phone}
                </a>{" "}
                or email{" "}
                <a href={site.emailHref} data-testid="thank-you-email" className="font-semibold text-ember-dark break-all">
                  {site.email}
                </a>
                .
              </p>
            </div>
            <div className="mt-10 flex flex-col justify-center gap-3 sm:flex-row">
              <Link
                to="/projects"
                data-testid="thank-you-projects-btn"
                className="inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full bg-ember px-7 py-3 text-sm font-semibold text-white transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-ember-dark"
              >
                Browse Project Ideas <ArrowRight className="h-4 w-4" aria-hidden="true" />
              </Link>
              <Link
                to="/"
                data-testid="thank-you-home-btn"
                className="inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full border border-slate-300 px-7 py-3 text-sm font-semibold text-slate-800 transition-colors duration-200 hover:border-ember hover:text-ember-dark"
              >
                Back to Home
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
